import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Switch,
    Tooltip
} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContentText from "@material-ui/core/DialogContentText";
import MfaRegistrationForm from "../../../containers/MfaRegistrationForm";
import { mfaResetRegistrationForm} from "../../../actions";
import {Col, Row} from "reactstrap";
import ComingSoonIconSettings from "./ComingSoonIconSettings";

const MFAToggleSwitch = ({customer=null, earlyAccess=false,})=>{

    const authUser = useSelector(({auth}) => auth.authUser);
    const {didJustVerifyForMFA, closeMFAForm} = useSelector(({auth}) => auth.appMisc);
    // const isAdmin = isCurrentUserMemberOf(authUser,"admin");
    // const isStaff = isCurrentUserMemberOf(authUser, "staff");

    const isDisabled = false;
    const textColor = isDisabled && "text-light-gray";

    const dispatch = useDispatch();


    console.log("Building MFA. Here is authUser:", authUser, isDisabled);

    const mfaState = authUser && authUser.security ? authUser.security : null;
    const isMfaEnabled = mfaState ? mfaState.mfa_enabled : false;
    const isMfaRequired = mfaState ? mfaState.mfa_required : false;

    const mfaPrefs = mfaState ? mfaState.mfa_preference : null;
    const primaryAuthMethod = mfaPrefs ? mfaPrefs.name : null;
    const recoveryPhone = mfaState? mfaState.mfa_phone_number : "None on file.";
    const recoveryEmail = mfaState? mfaState.mfa_email : "None on file.";


    //Switch Interface.
    //Switch should just read the Redux state and update accordingly.
    const [switchState, setSwitchState] = useState(isMfaEnabled);

    useEffect(() => {
        setSwitchState(isMfaEnabled);

        if(didJustVerifyForMFA || closeMFAForm) {
            setMfaOpen(false);

            //reset all the data related to the MFA form so it could be used again.
            dispatch(mfaResetRegistrationForm())
        }

    }, [authUser, didJustVerifyForMFA]);


    //MFA Form
    const [mfaOpen, setMfaOpen] = useState(false);

    const handleMfaFormOpen = () =>{
        setMfaOpen(true);
    }

    const handleMfaFormClose = () =>{
        setMfaOpen(false);
    }

    const mfaDialog = <Dialog open={mfaOpen}
        // fullScreen
                              maxWidth={"xl"}
                              onClose={handleMfaFormClose}
                              aria-labelledby="form-dialog-title">
        <DialogTitle id="customized-dialog-title" onClose={handleMfaFormClose}>
            <div className={"row"}>

                <div className={"col-6 p-0 m-0"}>

                </div>
                <div className={"col-11"}/>

                <div className={"col-1 text-right"}>

                    <IconButton
                        // variant={"s"}
                        // color={"lightest-gray"}
                        onClick={()=>handleMfaFormClose()}>
                        <CloseIcon/>
                    </IconButton>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-12 text-center"}>
                    <h1>Enable MFA</h1>
                    <p>Secure your account with multi-factor authentication. Use this form to register for your preferred contact method.</p>
                </div>
            </div>
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                <div className={"border-2 p-3 bg-lightest-gray"}>
                    <div style={{height: '90%'}}>
                        <MfaRegistrationForm/>

                    </div>
                </div>

            </DialogContentText>
        </DialogContent>

    </Dialog>

    return(
        <>
                <div className={"row mt-1"}>
                    <Tooltip title={""}>
                        <>
                            <p className={`col-5 text-right align-self-baseline ${textColor}`}>Multi-Factor Authentication:</p>
                            <p className={"col-1"}> </p>
                            <div className={"col-6 text-left border-1 p-2 bg-lightest-gray"}>
                                <Row>
                                    <Col xs={4}>
                                        <FormControlLabel control={
                                            <Switch
                                                isDisabled={isDisabled}
                                                color={"primary"}
                                                checked={switchState}
                                                size="medium"
                                                onClick={() => {
                                                    handleMfaFormOpen();
                                                }}
                                            />
                                        }
                                                          label={isMfaEnabled ? "Enabled" : "Disabled"}
                                                          disabled={isDisabled} //enabled for admins only
                                        />
                                    </Col>
                                    <Col xs={6}>
                                        <div className={"p-2"}>MFA <strong>{isMfaRequired ? "is." : "is not"}</strong> required.</div>
                                    </Col>
                                    <Col xs={1} className={`float-left ${textColor}`} style={{marginLeft: "-2%"}}>
                                        { isDisabled && <ComingSoonIconSettings/>}
                                    </Col>
                                </Row>
                                {mfaDialog}
                                { (!isDisabled && isMfaEnabled) &&
                                <>
                                    <Row>
                                        <hr/>
                                        <Col xs={5}>
                                            <h5>Primary Factor:</h5>
                                        </Col>
                                        <Col>
                                            <em>{isMfaEnabled ? primaryAuthMethod : "N/A"}</em>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={5}>
                                            <h5>Recovery Email:</h5>
                                        </Col>
                                        <Col xs={6}>
                                            {recoveryEmail ? <small><pre>{recoveryEmail}</pre></small> : <em>N/A</em>}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={5}>
                                            <h5>Recovery Phone:</h5>
                                        </Col>
                                        <Col xs={6}>
                                            {recoveryPhone ? <small><pre>{recoveryPhone}</pre></small> : <em>N/A</em>}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <small><em>To change your factor and recovery information, {isMfaEnabled ? "disable" : "enable"} MFA using the switch above{isMfaEnabled ? " and re-register" : ""}. Some information cannot be changed.</em></small>
                                        </Col>
                                    </Row>
                                </>
                                }
                            </div>
                        </>
                    </Tooltip>
                </div>
        </>

    )
}

export default MFAToggleSwitch;